export default String.raw`
$(document).ready(()=>{
    $(".newsSection").each((_i, item) => {
        const $item = $(item);
        const name = $item.data("name");
        const numberOfSlides = $item.find(".newsSection__wrapper").data("len");

        const filter = $item.data("link");
        const data = {__action: "Get/SearchAdvanced", tos: "search", flags: filter};

        if (data.flags !== false) {
            $.post(null, data, (res) => {
                const url = res.action.Redirect302;
                $item.find(".newsSection__header a").attr("href", url);
            });
        }

       new Swiper("." + name, {
            centerInsufficientSlides: true,
            navigation: {
                nextEl: '.' + name + '__next',
                prevEl: '.' + name + '__prev',
            },
            breakpoints: {
                0: {
                    loop: (numberOfSlides > 2),
                    spaceBetween: 16,
                    slidesPerView: 1.4
                },
    
                769: {
                    loop: (numberOfSlides > 3),
                    spaceBetween: 24,
                    slidesPerView: 2.6
                },
    
                1440: {
                    loop: (numberOfSlides > 5),
                    spaceBetween: 24,
                    slidesPerView: 4.1
                }
            },
            a11y: false,
			keyboard: {
                enabled: true,
				pageUpDown: true
            },
			watchSlidesProgress: true,
            slideToClickedSlide: true,
            scrollOnFocus: true,
			on: {
                init: function () {
                    app.manageTabIndexInsideSlide(this);
                },
                slideChangeTransitionEnd: function () {
                    app.manageTabIndexInsideSlide(this);
                }
            },
        });
    });
});
`